import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { fromEvent, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[locktonAppsDynamicTextarea]',
  standalone: true,
})
export class DynamicTextareaDirective implements OnInit, OnDestroy {
  private readonly destroyer$: Subject<void> = new Subject();

  constructor(
    private readonly host: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.wrap();
    this.listenToChanges();
    this.onChange();
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  private wrap(): void {
    const wrapper: HTMLElement = this.renderer.createElement('div');
    const textarea: HTMLElement = this.host.nativeElement;

    this.renderer.addClass(wrapper, 'lui-dynamic-textarea');
    this.renderer.insertBefore(textarea.parentNode, wrapper, textarea);
    this.renderer.appendChild(wrapper, textarea);
  }

  private listenToChanges(): void {
    this.addEventListener('input', this.onChange);
  }

  private addEventListener(event: string, handler: () => void): void {
    fromEvent(this.host.nativeElement, event)
      .pipe(takeUntil(this.destroyer$))
      .subscribe(handler.bind(this));
  }

  private onChange(): void {
    this.host.nativeElement.parentNode.dataset.value =
      this.host.nativeElement.value;
  }
}
